import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const getDefaultState = () => {
  return {
    created: null,
    geolocation: null,
    topDestinations: {}
  }
}

const state = getDefaultState()

mutations.RESET_STATE = (state) => {
  Object.assign(state, getDefaultState())
}
actions.reset = ({ commit }) => {
  commit('RESET_STATE')
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/communication/countries/index.js